import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  InputAdornment,
  FormControl,
  Select,
} from "@mui/material";
import MUITypography from "../../../Components/MUITypography";
import { SESSION_USER_COUNTRY_DATA_KEY } from "../../../Util/VMConstants";
import StorageFactory from "../../../Util/StorageFactory";
import { handleWheel } from "../../../Util/UtilHelper";

const discountRowGrid = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
  alignItems: "center",
  columnGap: 1,
  py: 1,
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
};

function Discount({
  discountType = "percentage",
  discountValue = "",
  onTypeChange,
  onValueChange,
}) {
  const sessionFactory = new StorageFactory("session");
  const currencySymbol =
    sessionFactory.get(SESSION_USER_COUNTRY_DATA_KEY)?.currency_symbol || "₹";

  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <MUITypography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
        Discount
      </MUITypography>

      <Box sx={discountRowGrid}>
        <MUITypography
          variant="body1"
          sx={{
            color: "#444",
            fontWeight: 500,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          Discount type
        </MUITypography>
        <MUITypography variant="body1" sx={{ color: "#888" }}>
          
        </MUITypography>
        <FormControl
          size="small"
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            justifySelf: "stretch",
          }}
        >
          <Select
            value={discountType}
            onChange={(e) => onTypeChange(e.target.value)}
          >
            <MenuItem value="percentage">Percentage (%)</MenuItem>
            <MenuItem value="flat">Flat ({currencySymbol})</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={discountRowGrid}>
        <MUITypography
          variant="body1"
          sx={{
            color: "#444",
            fontWeight: 500,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          Discount value
        </MUITypography>
        <MUITypography variant="body1" sx={{ color: "#888" }}>
          
        </MUITypography>
        <TextField
          size="small"
          type="number"
          value={discountValue}
          placeholder="0"
          onChange={(e) => {
            const sanitized = (e.target.value || "").replace(/[^\d.]/g, "");
            onValueChange(sanitized);
          }}
          onWheel={handleWheel}
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {discountType === "percentage" ? "%" : currencySymbol || "₹"}
              </InputAdornment>
            ),
            inputProps: { style: { MozAppearance: "textfield" }, inputMode: "numeric" },
          }}
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            justifySelf: "stretch",
            "& input[type=number]": {
              MozAppearance: "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default Discount;
